<template>
    <div>
        <div v-show="!creatActInAction">
            <div class="row">
                <div class="col">
                    <span style="margin-left: 5px; font-size: 18px; display: inline-block;"><strong>Состояние Предпринимательского счета</strong>: {{ extraInfo.on_account | localInt }}
                        руб.</span> <br>
                    <span style="margin-left: 5px; font-size: 18px; display: inline-block;"><strong>Доступно к Выводу</strong>: {{ extraInfo.avail_amount | localInt }}
                        руб.</span>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col">
                    <span style="margin-left: 5px; font-size: 18px; display: inline-block;">Минимальная сумма Вывода в акте: {{extraInfo.act_min | localInt}} руб</span>
                    <br>
                    <span style="margin-left: 5px; font-size: 18px; display: inline-block;">Максимальная сумма Вывода в акте: {{extraInfo.act_max | localInt}}
                        руб</span>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col custom_input">
                    <input type="text" name="sum" id="sum" v-model="sum" required v-currency="{
                        currency: null,
                        valueAsInteger: false,
                        distractionFree: false,
                        allowNegative: false
                    }" />
                    <label for="sum">
                        {{ $t("к Выводу") }}
                    </label>
                    <span class="clear_icon" @click="clearSum()"></span>
                </div>
            </div>
            <span style="color: red; display: inline-block; margin-left: 5px;"
                v-show="showErrorMsg">{{ errorMsg }}</span>
            <div class="row">
                <div class="col">
                    <button :class="`btn_type_2 ${isBtnDisabled || isPdfLoading ? 'disabled' : ''}`" :disabled="isBtnDisabled || isPdfLoading" @click="showUnsignedActInfo">
                        {{ isPdfLoading ? 'Загрузка файла' : 'Предпросмотр акта' }}
                    </button>
                </div>
                <div class="col">
                    <button :class="`btn_type_1 ${isBtnDisabled ? 'disabled' : ''}`" :disabled="isBtnDisabled"
                        @click="creatAct">Подписать акт</button>
                </div>
            </div>
        </div>
        <div v-show="creatActInAction">
            <div class="row align-items-end">
                <div class="col custom_input">
                    <input v-model="smsCode" type="text" name="rls" id="rls" required />
                    <label for="rls">{{ $t("Код из SMS") }}</label>
                    <span class="clear_icon" @click="clearSMSCode()"></span>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <button :class="`btn_type_1 ${smsCode === '' ? 'disabled' : ''}`" :disabled="smsCode === ''"
                        @click="sendSmsCode">Подтвердить</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import backAPI from '../assets/backApi';

export default {
    name: 'CreateActModal',
    data() {
        return {
            sum: '',
            creatActInAction: false,
            isPdfLoading: false,
            smsHash: '',
            smsCode: '',
            extraInfo: {
                act_min: 0,
                act_max: 0,
                avail_amount: 0,
                amount: 0,
            },
        };
    },
    mounted() {
        backAPI.get('agent/act-amount').then(Response => {
            this.extraInfo = Response.data;
        });
    },
    methods: {
        async showUnsignedActInfo() {
        this.isPdfLoading = true;
        await backAPI.get('/agent/act-preview-unsigned',
            {
            responseType: 'blob',
            params: {
                act_amount: Number(this.sum.replace(/\s/gi, '').replace(/[,]/gi, '.')),
            },
            })
            .then(({ data }) => {
            const filename = `${this.$t('Пример акта')}.pdf`;
            const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            });
            this.isPdfLoading = false;
        },
        clearSum() {
            this.sum = '';
        },
        creatAct() {
            backAPI.post('/agent/act-sign-start').then(Response => {
                this.smsHash = Response.data;
            });
            this.creatActInAction = true;
        },
        async sendSmsCode() {
            const params = {
                sms_code: this.smsCode,
                hash_content: this.smsHash,
                amount: Number(this.sum.replace(/\s/gi, '').replace(/[,]/gi, '.')),
            };
            await backAPI.post('/agent/act-sign-end', params).then(() => {
                this.creatActInAction = false;
                this.$emit('close');
            });
        },
        clearSMSCode() {
            this.smsCode = '';
        },
    },
    computed: {
        errorMsg() {
            if (this.sum.replace(/\s/gi, '').replace(/[,]/gi, '.') > this.extraInfo.avail_amount) {
                if ((this.sum.replace(/\s/gi, '').replace(/[,]/gi, '.') > this.extraInfo.act_max && this.sum !== '')) {
                    return 'Сумма больше максимальной';
                }
                return 'Сумма выше лимита на вывод по актам за предыдущий период';
            }
            if ((this.sum.replace(/\s/gi, '').replace(/[,]/gi, '.') < this.extraInfo.act_min && this.sum !== '')) {
                return 'Сумма меньше минимальной';
            }
            if ((this.sum.replace(/\s/gi, '').replace(/[,]/gi, '.') > this.extraInfo.act_max && this.sum !== '')) {
                return 'Сумма больше максимальной';
            }
            return '';
        },
        showErrorMsg() {
            if (this.sum.replace(/\s/gi, '').replace(/[,]/gi, '.') > this.extraInfo.avail_amount) {
                return true;
            }
            if ((this.sum.replace(/\s/gi, '').replace(/[,]/gi, '.') < this.extraInfo.act_min && this.sum !== '')) {
                return true;
            }
            if ((this.sum.replace(/\s/gi, '').replace(/[,]/gi, '.') > this.extraInfo.act_max && this.sum !== '')) {
                return true;
            }
            return false;
        },
        isBtnDisabled() {
            if (this.sum === '') return true;
            if (this.sum.replace(/\s/gi, '').replace(/[,]/gi, '.') > this.extraInfo.avail_amount) return true;
            if (this.sum !== '' && (this.sum.replace(/\s/gi, '').replace(/[,]/gi, '.') < this.extraInfo.act_min
            || this.sum.replace(/\s/gi, '').replace(/[,]/gi, '.') > this.extraInfo.act_max)) return true;
            return false;
        },
    },
};
</script>
